import { Campaign } from '@tinct/core-api-models';

/**
 * Whether this campaign already has generated variant pages that an edit would
 * outdate — the single condition behind the funnel's "these changes aren't live
 * yet" notice.
 *
 * `draft` is the only status with nothing to outdate; `ready`, `published` and
 * `unpublished` all imply a completed generation. `unpublished` counts too:
 * those pages exist and are now stale, so they still need regenerating before
 * the campaign goes back up — skipping the notice there would let a user
 * republish content generated from a superseded version.
 *
 * Requires `status` and `statistics.totalPagesCount` in the projection.
 *
 * Whether a *single page* has drifted from its live version is a different
 * question, answered per page in the previewer via `usePublishedEditNotice`.
 */
export function campaignHasGeneratedPages(campaign?: Campaign | null): boolean {
  const status = campaign?.status;
  const pagesCount = campaign?.statistics?.totalPagesCount ?? 0;

  return (
    (status === 'ready' || status === 'published' || status === 'unpublished') &&
    pagesCount > 0
  );
}
